<template>
  <button v-show="isVisible" class="back-to-top" @click="scrollToTop" />
</template>

<script setup lang="ts">
import _ from 'lodash'
import { ref, onMounted, onUnmounted } from 'vue'

import scroll from '@/lib/utils/scroll'

const isVisible = ref(false)

const handleScroll = _.throttle(() => {
  const scrollThreshold = window.innerHeight * 2
  isVisible.value = window.scrollY > scrollThreshold
}, 100)

const scrollToTop = () => {
  scroll.pageToTop()
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>
